module.exports = __webpack_public_path__ + "img/Blue.e4898265.jpg";